export default __webpack_public_path__ + "static/media/perHour.1e397cd8.png";